function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledDownloadMobileAppComponent } from "./download-mobile-app-component.scss";
import PictureComponent from "components/core/picture/picture-component";
import { isAndroid } from "/utils/mobile";
import { ONELINK_MOBILE_APP_URL } from "/constants/links";
import { trackEvent } from "/services/bigbrain-service";
import { HP_STORE_CLICKED } from "/constants/bigbrain-event-types";
const ANDROID_SRC = "https://dapulse-res.cloudinary.com/image/upload/mobile_menu/google-play-badge.png";
const IPHONE_SRC = "https://dapulse-res.cloudinary.com/image/upload/mobile_menu/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917_1.png";
class DownloadMobileAppComponent extends PureComponent {
    componentDidMount() {
        this.setState({
            isAndroidPhone: isAndroid()
        });
    }
    render() {
        const { isAndroidPhone } = this.state;
        const imgSrc = isAndroidPhone ? ANDROID_SRC : IPHONE_SRC;
        return /*#__PURE__*/ _jsx(StyledDownloadMobileAppComponent, {
            className: "download-mobile-app-component af-smart-button",
            href: ONELINK_MOBILE_APP_URL,
            onClick: this.trackDownload,
            children: /*#__PURE__*/ _jsx(PictureComponent, {
                src: imgSrc,
                className: "download-mobile-app-image"
            })
        });
    }
    constructor(props){
        super(props);
        _define_property(this, "trackDownload", ()=>{
            const { isAndroidPhone } = this.state;
            trackEvent(HP_STORE_CLICKED, {
                kind: isAndroidPhone ? "android" : "ios"
            });
        });
        this.state = {
            isAndroidPhone: false
        };
    }
}
export { DownloadMobileAppComponent as default };
